
(function () {
  const CUSTOM_VALUE = 'Create Your Own';
  const OPTION_NAME = 'Flavor';                  // name radio = "Flavor-1"
  const SLOTS = 4;
  const PROP_PREFIX = 'BISCOTTI FLAVOR #';       // properties[BISCOTTI FLAVOR #1] ... #4
                                                 // -> trong gio hang / don hang hien
                                                 //    "BISCOTTI FLAVOR #1: Turtle"

  const PICKER_ID = 'customMixPicker';
  const ROWS_ID = 'customMixRows';
  const ERROR_ID = 'customMixErrorMsg';
  const PLACEHOLDER = 'FLAVOR ';                 // "FLAVOR 1" khi chua chon
  const EXCLUDE = /ribbon|collection|create your own/i;

  /* ---------- state — song ngoai DOM ---------- */
  const picks = [];
  for (let i = 0; i < SLOTS; i++) picks.push(null);

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ---------- dang o Create Your Own? ---------- */
  function isActive() {
    const radios = Array.from(document.querySelectorAll('variant-selects input[type="radio"], variant-radios input[type="radio"]'));
    const mine = radios.filter(function (r) { return r.name.trim().toLowerCase().indexOf(OPTION_NAME.toLowerCase()) === 0; });
    if (mine.length) {
      const on = mine.filter(function (r) { return r.checked; })[0];
      return !!on && on.value.trim() === CUSTOM_VALUE;
    }
    return !!document.getElementById(PICKER_ID);
  }

  function rowsEl() { return document.getElementById(ROWS_ID); }
  function wraps() {
    const r = rowsEl();
    return r ? Array.from(r.querySelectorAll('.cd-wrap')) : [];
  }

  /* ---------- fallback: theme khong render san slot ---------- */
  function flavorListFromDropdown() {
    const menu = document.querySelector('.fd-wrap .fd-menu');
    if (!menu) return [];
    const kids = Array.from(menu.children);
    let start = kids.findIndex(function (k) {
      return k.classList.contains('fd-group-header') && /individual/i.test(k.textContent);
    });
    const seen = {};
    const out = [];
    kids.slice(start + 1).forEach(function (k) {
      if (!k.classList.contains('fd-option')) return;
      const v = (k.getAttribute('data-value') || k.textContent).trim();
      if (!v || seen[v] || EXCLUDE.test(v)) return;
      seen[v] = true;
      out.push(v);
    });
    return out;
  }

  function buildFallbackSlots() {
    const r = rowsEl();
    if (!r) return;
    const flavors = flavorListFromDropdown();
    if (!flavors.length) return;
    let html = '';
    for (let i = 0; i < SLOTS; i++) {
      html +=
        '<div class="mix-row"><span class="mix-num">#' + (i + 1) + '</span>' +
        '<div class="cd-wrap"><button type="button" class="cd-trigger"><span><span class="cd-trigger-label">' + PLACEHOLDER + (i + 1) + '</span></span>' +
        '<span class="cd-chevron"><svg width="12" height="8" viewBox="0 0 12 8" fill="none"><path d="M1 1.5L6 6.5L11 1.5" stroke="#9B9B9B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span></button>' +
        '<div class="cd-menu">' + flavors.map(function (f) {
          return '<div class="fd-option" data-value="' + esc(f) + '"><span><div class="fd-option-name"><span class="fd-option-name-text">' + esc(f) + '</span></div></span></div>';
        }).join('') + '</div></div></div>';
    }
    r.innerHTML = html;
  }

  /* ---------- do state len markup co san ---------- */
  // Chi ghi khi khac — MutationObserver duoi se goi lai ham nay sau moi lan
  // DOM doi, ghi lai y het la tu kich vo han.
  function applyPicks() {
    wraps().forEach(function (wrap, i) {
      if (i >= SLOTS) return;
      const cur = picks[i];
      const label = wrap.querySelector('.cd-trigger-label');
      if (label) {
        const want = cur || (PLACEHOLDER + (i + 1));
        if (label.textContent.trim() !== want) label.textContent = want;
        const fw = cur ? '' : '400';
        if (label.style.fontWeight !== fw) label.style.fontWeight = fw;
        const col = cur ? '' : 'var(--support-gray, #808080)';
        if (label.style.color !== col) label.style.color = col;
      }
      wrap.querySelectorAll('.cd-menu .fd-option').forEach(function (o) {
        const on = !!cur && o.getAttribute('data-value') === cur;
        if (o.classList.contains('selected') !== on) o.classList.toggle('selected', on);
      });
    });
  }

  function render() {
    const active = isActive();
    syncForm(active);
    if (!active) return;
    if (rowsEl() && !wraps().length) buildFallbackSlots();
    applyPicks();
  }

  /* ---------- ghi vao form gio hang ---------- */
  function cartForms() {
    return Array.from(document.querySelectorAll('form[action*="/cart/add"]')).filter(function (f) {
      return f.querySelector('input[name="id"]');
    });
  }

  function syncForm(active) {
    cartForms().forEach(function (form) {
      // anchor chay dan: input 1 sau [name=id], input 2 sau input 1, ...
      // Chen tat ca ngay sau [name=id] thi cai sau de len cai truoc -> 4 3 2 1.
      let anchor = form.querySelector('input[name="id"]');
      for (let i = 0; i < SLOTS; i++) {
        const name = 'properties[' + PROP_PREFIX + (i + 1) + ']';
        let input = form.querySelector('input[name="' + name + '"]');
        const val = active ? (picks[i] || '') : '';
        if (!val) { if (input) input.remove(); continue; }
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
        }
        // Chi di chuyen khi chua dung cho — di chuyen thua se kich MutationObserver
        if (anchor.nextElementSibling !== input) anchor.insertAdjacentElement('afterend', input);
        if (input.value !== val) input.value = val;
        anchor = input;
      }
    });
  }

  function isComplete() { return picks.every(Boolean); }

  function emit() {
    document.dispatchEvent(new CustomEvent('gg:custommix', { detail: { picks: picks.slice(), complete: isComplete() } }));
  }

  function setPick(i, value) {
    if (i < 0 || i >= SLOTS) return;
    picks[i] = value || null;
    const err = document.getElementById(ERROR_ID);
    if (err && isComplete()) err.style.display = 'none';
    render();
    emit();
  }

  function reset() {
    for (let i = 0; i < SLOTS; i++) picks[i] = null;
    render();
    emit();
  }

  /* ---------- listeners: capture phase, tren document ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    const rows = rowsEl();
    const inRows = rows && rows.contains(e.target);

    // 1. chon mot vi
    const opt = inRows && e.target.closest('.cd-menu .fd-option');
    if (opt) {
      e.stopPropagation();       // script dropdown chinh (bundle) co handler bubble
      const wrap = opt.closest('.cd-wrap');
      wrap.classList.remove('open');
      setPick(wraps().indexOf(wrap), opt.getAttribute('data-value'));
      return;
    }

    // 2. bam trigger -> mo/dong slot do, dong slot khac
    //    stopPropagation: nhanh "bam ra ngoai" cua bundle goi closeAll() xoa
    //    .cd-wrap.open o MOI noi, chay ngay sau capture nay va dong lai cai vua mo.
    const trig = inRows && e.target.closest('.cd-trigger');
    if (trig) {
      e.stopPropagation();
      const wrap = trig.closest('.cd-wrap');
      const willOpen = !wrap.classList.contains('open');
      document.querySelectorAll('.cd-wrap.open, .fd-wrap.open').forEach(function (w) { w.classList.remove('open'); });
      if (willOpen) wrap.classList.add('open');
      return;
    }

    // 3. bam ra ngoai -> dong cac slot dang mo
    if (rows) rows.querySelectorAll('.cd-wrap.open').forEach(function (w) { w.classList.remove('open'); });
  }, true);

  // Doi variant (radio Flavor) -> Dawn render lai; cho no xong roi do lai state
  document.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'radio') setTimeout(render, 0);
  }, true);

  /* ---------- chan Add to cart khi chua du 4 ---------- */
  function block(e) {
    if (!isActive() || isComplete()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const err = document.getElementById(ERROR_ID);
    if (err) err.style.display = 'block';
    const picker = document.getElementById(PICKER_ID);
    if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  document.addEventListener('click', function (e) {
    const btn = e.target && e.target.closest && e.target.closest('button[name="add"], .product-form__submit');
    if (btn) block(e);
  }, true);
  document.addEventListener('submit', function (e) {
    const f = e.target;
    if (f && f.matches && f.matches('form[action*="/cart/add"]')) block(e);
  }, true);

  /* ---------- Dawn render lai section -> do state len markup moi ---------- */
  // setTimeout, khong requestAnimationFrame: rAF dat lich tu trong callback cua
  // MutationObserver co the khong bao gio chay, latch se ket vinh vien.
  let queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      try { render(); } catch (err) { if (window.console) console.error('[custom-mix]', err); }
    }, 0);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();

  window.ggCustomMix = {
    get: function () { return picks.slice(); },
    set: setPick,
    reset: reset,
    render: render,
    isActive: isActive,
    isComplete: isComplete
  };
})();
